import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import EditableCard from 'modules/common/editableCard.component';

const styles = (theme) => ({
  accordionStyle: {
    maxWidth: 1050,
  },
  inputGroup: {
    display: 'inline-flex',
    justifyContent: 'space-between',
  },
  root: {
    minWidth: 350,
  },
  webRoot: {
    minWidth: 315,
  },
  mediumRoot: {
    minWidth: 200,
  },
  miniRoot: {
    width: 140,
  },
  detailsLayout: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    width: '100%',
  },
  contentCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  dualField: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  divider: {
    width: 350,
    marginRight: theme.spacing(1),
  },
  checkbox: {
    paddingTop: 15,
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    alignContent: 'center',
  },
});

const TaxesAndOtherInfoCard = props => {
  
  const { clientDetails } = props;

  const summaryTabs = [{ header: 'Taxes & Other Info', order: 1, iconPath: ['fas', 'fa-money-check-alt'] }];

  const fields = [
    { header: 'Tax Id', accessorKey: 'ein', type: 'text', required: false, value: clientDetails ? clientDetails.ein : '', tab: 1 },
    { header: 'Dunn and Bradstreet', accessorKey: 'dunnBradstreetNumber', type: 'text', required: false, value: clientDetails ? clientDetails.dunnBradstreetNumber : '', tab: 1 },
    { header: 'Contract Start', accessorKey: 'contractStartDate', type: 'text', required: false, value: clientDetails ? clientDetails.contractStartDate : null, tab: 1 },
    { header: 'Contract End', accessorKey: 'contractEndDate', type: 'text', required: false, value: clientDetails ? clientDetails.contractEndDate : null, tab: 1 },
  ];
    
  return (
      <EditableCard tabs={summaryTabs} summaries={fields} numColumns={2} isLoading={props.isLoading} hideEdit={true} />
  );
};

TaxesAndOtherInfoCard.propTypes = {
  classes: PropTypes.object.isRequired,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
};
  
export default compose(
  withStyles(styles),
)(TaxesAndOtherInfoCard);